import React from "react";
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Moment from 'moment';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { CgCloseR } from "react-icons/cg";

const HolidayRequestDetailsNode = ({ rights, t, isDisabled, data, events, css }) => {
    const [key, setKey] = useState('home');

    useEffect(() => {
        // //console.log("dddddddddd", data)
        console.log("data", data.record)
    }, [data]);

    return (
        <>
         <label className='labelhotel'>{t('requester')}</label>
         <label className='blacklabel'>{/*data.record.Hotel_ID+" "+*/data.record.voornaam +", "+data.record.achternaam}</label>

            <label className='labelhotel'>{t('Startdatum')}</label>
            <input type="date" id="startdatum" name="startdatum" value={Moment(data.record.startdatum).format('yyyy-MM-DD')} className='date2' disabled={isDisabled} />
            <label className='labelhotel'>{t('Einddatum')}</label>
            <input type="date" id="startdatum" name="startdatum" value={Moment(data.record.einddatum).format('yyyy-MM-DD')} className='date2' disabled={isDisabled} />
            {/* <label className='labelhotel'>{t('dag')}</label> */}
            {/* <fieldset className="formElementfieldset_holiday" disabled={isDisabled} value={data.record.daytype}>
                <input type="radio" id="geslacht_1" name="daytype" value="0" className="radio" checked={data.record.daytype === 0 ? true : false} />
                <label for="daytype_0" className="radiolabel"> {t('heledag')}</label>

                <input type="radio" id="geslacht_2" name="daytype" value="1" className="radio" checked={data.record.daytype === 1 ? true : false} />
                <label for="daytype_1" className="radiolabel"> {t('voormiddag')}</label>

                <input type="radio" id="geslacht_3" name="daytype" value="2" className="radio" checked={data.record.daytype === 2 ? true : false} />
                <label for="daytype_2" className="radiolabel"> {t('namiddag')}</label>
            </fieldset>
            <label className='labelhotel'>{t('Type')}</label>

            <select className='date2' defaultValue="1" name="typeaanvraag" id="typeaanvraag" value={data.record.typeaanvraag} disabled={isDisabled}>
                <option value="1">{t('jaarlijksVerlof')}</option>
                <option value="2">{t('familiaalverlof')}</option>
                <option value="3">{t('ander')}</option>
            </select> */}
            <label className='labelhotel'>{t('Redenaanvraag')}</label>
            <textarea id="Reason" name="reden" className="textareaReason2" value={data.record.reden !== null ? data.record.reden : ""} disabled={isDisabled}></textarea>


        </>
    );
}


export default HolidayRequestDetailsNode;
